<template>
    <div>
        <div id="wrapper-bg" class="position-absolute" :class="{'slideUp2':show}" v-bind:style="styleWrapper"></div>
        <div class="front-container d-md-flex align-items-center container overflow-hidden">
            <div class="row w-100 justify-content-center justify-content-lg-start">
                <div class="col">
                    <div v-if="showMessage" class="login-alert alert d-flex p-2 align-items-center" :class="typeAlert">
                        <div>
                            <i class="ms-Icon ms-Icon--ErrorBadge" v-if="typeAlert=='alert-danger'"></i>
                            <i class="ms-Icon ms-Icon--Info" v-else></i>
                        </div>
                        <span class="pl-2">{{message}}</span>
                    </div>
                    <router-view @updateMessage="updatedMessage" @hideMessage="showMessage=false" />
                </div>
            </div>
        </div>
        <Footer fixed></Footer>
    </div>
</template>

<script>
    import Footer from '@/views/layout/Footer.vue';
    export default {
        name: 'Front',
        components: {
            Footer
        },
        mounted() {
            let self = this;
            setTimeout(() => { self.show=true; }, 500);
        },
        data() {
            return {
                showMessage: false,
                show: false,
                typeAlert: '',
                styleWrapper: {
                    'background-image': 'url("' + (this.$Params.img_background ? (this.$Params.urlBase + this.$Params.img_background) : (this.$Params.urlImages + 'background')) + '")'
                }
            }
        },
        methods: {
            updatedMessage(v, type, timer) {
                this.typeAlert = `alert-${type}`;
                this.message = v;
                if(typeof timer == undefined) this.showMessage = true;
                else setTimeout(() => {
                    this.showMessage = true;
                }, timer);
            }
        }
    }

</script>